'use client'

import { useEffect } from 'react'

import ClientErrorPage from '@maestro/commerce-blocks/components/client-error-page'
import {
  handleChunkLoadError,
  isChunkLoadError,
} from '@maestro/commerce-blocks/utils/chunk-error.utils'
import { theme } from '@maestro/local/theme'

export default function Error({
  error,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    if (isChunkLoadError(error)) {
      handleChunkLoadError()
    }
  }, [error])

  return (
    <ClientErrorPage
      error={error}
      showErrorInfo={
        process.env.NODE_ENV === 'development' ||
        theme().site.showSiteErrorDetails
      }
    />
  )
}
